export class Rtable{
    static default:string = 'txt';
    static structure:any = {
        key:'rank',
        title:'名次',
        title_cls_dk:'width5percent',
        title_cls_mb:'',
        type:'num',
        type_cls_dk:'',
        type_cls_mb:'',
        unit:'',
        sort:0,
    };
   
    

    static  init(rename_data:any){
        const result = [];
        for(let i in rename_data){
            let type = this.structure.type ;
            if(typeof(rename_data[i].type)!='undefined'){
                type = rename_data[i].type;
            }

            let title_cls_dk = this.structure.title_cls_dk ;
            if(typeof(rename_data[i].title_cls_dk)!='undefined'){
                title_cls_dk = rename_data[i].title_cls_dk;
            }
            let title_cls_mb = this.structure.title_cls_mb ;
            if(typeof(rename_data[i].title_cls_mb)!='undefined'){
                title_cls_mb = rename_data[i].title_cls_mb;
            }
            let type_cls_dk = this.structure.type_cls_dk ;
            if(typeof(rename_data[i].type_cls_dk)!='undefined'){
                type_cls_dk = rename_data[i].type_cls_dk;
            }
            let type_cls_mb = this.structure.type_cls_mb ;
            if(typeof(rename_data[i].type_cls_mb)!='undefined'){
                type_cls_mb = rename_data[i].type_cls_mb;
            }
            let unit = this.structure.unit ;
            if(typeof(rename_data[i].unit)!='undefined'){
                unit = rename_data[i].unit;
            }
            let sort = this.structure.sort ;
            if(typeof(rename_data[i].sort)!='undefined'){
                sort = rename_data[i].sort;
            }
           
           let tmp = {
                title:rename_data[i].name,
                key:i,
                type:type,
                title_cls_dk:title_cls_dk,
                title_cls_mb:title_cls_mb,
                type_cls_dk:type_cls_dk,
                type_cls_mb:type_cls_mb,
                unit:unit,
                sort:sort,
            }
            
            result.push(tmp)
        }
        return result;

    }
}